@if (service.loading()) {
  <div class="loading-spinner">
    <bricks-progress-spinner [mode]="'indeterminate'"></bricks-progress-spinner>
    @if (service.message(); as message) {
      <span>{{ message }}</span>
    }
  </div>
}
